import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsLoad = boolean;
type CampaignId = number | null;
type BannerId = number | null;

// ----------------------- actions -------------------------------------
const SET_LOAD_BANNER_ADMIN_ACTION = 'SET_LOAD_BANNER_ADMIN_ACTION';
const SET_ID_FOR_BANNER_ADMIN_ACTION = 'SET_ID_FOR_BANNER_ADMIN_ACTION';

interface PayloadTypes {
    [SET_LOAD_BANNER_ADMIN_ACTION]: IsLoad;
    [SET_ID_FOR_BANNER_ADMIN_ACTION]: { campaignId: CampaignId; bannerId: BannerId };
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setLoadBannerAdminAction = ActionCreator(SET_LOAD_BANNER_ADMIN_ACTION);
export const setIdAdminAction = ActionCreator(SET_ID_FOR_BANNER_ADMIN_ACTION);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface AdminBannerActionState {
    isLoad: IsLoad;
    campaignId: CampaignId;
    bannerId: BannerId;
}

export const ADMIN_BANNER_ACTION_INITIAL_STATE: AdminBannerActionState = {
    isLoad: false,
    campaignId: null,
    bannerId: null,
};

export default createReducer<AdminBannerActionState, PayloadTypes>(ADMIN_BANNER_ACTION_INITIAL_STATE, {
    [SET_LOAD_BANNER_ADMIN_ACTION]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_ID_FOR_BANNER_ADMIN_ACTION]: (state, { payload }) => ({
        ...state,
        campaignId: payload.campaignId,
        bannerId: payload.bannerId,
    }),
});
// ----------------------- /reducer --------------------------------------
